import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import OtherContact from './OtherContact';
import Spinner from '../../Spinner/Spinner';
import ContactCard from '../../Contact/ContactCard';
import TitleWithCard from '../../Title/TitleWithCard';
import NoContact from '../../../containers/NoContact';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

class ChoiceView extends Component {
  state = {
    showNoContactPage: false,
  };

  componentDidMount() {
    const { identitiesId, getIdentitiesAndContacts } = this.props;

    getIdentitiesAndContacts(identitiesId);
  }

  /**
   * When the user click on the link, he will delete his contacts contacts and see if he can receive a letter
   */
  handleNoAccess = () => {
    const { deleteContactsList } = this.props;

    TagService.sendAction('noContactLink');
    this.setState({ showNoContactPage: true });
    deleteContactsList();
  };

  /**
   * Handler click
   * Send reports to GA
   * Set selected contact
   * Send OTC with selected contact
   */
  handleClick = (contact) => {
    const { sendOtp, setSelectedContact, isFetching } = this.props;

    if (!isFetching) {
      TagService.sendAction(contact.contactType.toLowerCase() === 'm' ? 'resetBySms' : 'resetByMail');
      setSelectedContact(contact);
      sendOtp({ contact });
    }
  };

  /**
   * String link wording
   * @return {*}
   */
  getLinkWording = () => {
    const { contacts } = this.props;
    if (contacts.length >= 2) {
      return WordingService.getWording('caption', 'noContactAccess');
    }
    if (contacts.length === 1) {
      if (contacts[0].contactType === 'M') {
        return WordingService.getWording('caption', 'noMobileAccess');
      }
      
      if (contacts[0].contactType === 'E') {
        return WordingService.getWording('caption', 'noEmailAccess');
      }
    }
    return '';
  };

  /**
   * Display the contacts when is fetched, else show a spinner.
   * Show a message page when have no contacts or click on the no-contact link
   * @return {*}
   */
  render() {
    const { showNoContactPage } = this.state;
    const {
      contacts,
      isFetching,
      showLink,
    } = this.props;

    const text = this.getLinkWording();

    if (isFetching) {
      return <Spinner />;
    }
    if (showNoContactPage || contacts.length === 0) {
      return <NoContact />;
    }

    return (
      <div id="choice-form">
        <Row>
          <Col xs={12} sm={12} md={9} lg={6} xl={6}>
            <TitleWithCard
              idLabel="choice-label"
              idIcon="choice-help"
              title={WordingService.getWording('title', 'getCode')}
              hint={contacts.length > 1 ? WordingService.getWording('hint', 'multipleContacts') : WordingService.getWording('hint', contacts[0].contactType.toLowerCase() === 'm' ? 'mobileContact' : 'mailContact')}
              onIconClick={() => TagService.sendAction('helpCanal')}
            />
            {contacts.map((contact, key) => <ContactCard id={key} key={contact.contactId} icon={contact.contactType.toLowerCase() === 'm' ? 'messaging' : 'email'} contact={contact} onClick={this.handleClick} />)}
            <br />
            {showLink && <OtherContact onClick={this.handleNoAccess} text={text} />}
          </Col>
        </Row>
      </div>
    );
  }
}

ChoiceView.defaultProps = {
  contacts: [],
  showLink: true,
  isFetching: true,
};

ChoiceView.propTypes = {
  /** Action to get all no sensitive data of the user */
  getIdentitiesAndContacts: PropTypes.func.isRequired,
  /** Action to create an otp with the selected contact way by calling partners api */
  sendOtp: PropTypes.func.isRequired,
  /** Action to set the contact way user preference */
  setSelectedContact: PropTypes.func.isRequired,
  /** User identity hash state */
  identitiesId: PropTypes.string.isRequired,
  /** Delete all contacts list for the current identities */
  deleteContactsList: PropTypes.func.isRequired,
  /** Array contact list */
  contacts: PropTypes.arrayOf(PropTypes.shape({
    contactId: PropTypes.string,
    contactView: PropTypes.string,
    contactType: PropTypes.string,
    contactValidity: PropTypes.string,
  })),
  /** Boolean display link when user have no access */
  showLink: PropTypes.bool,
  /** Boolean fetching data */
  isFetching: PropTypes.bool,
};

export default ChoiceView;
